export enum THEME_TYPE {
  SPACING = 'spacing',
  SIZING = 'sizing',
  BORDER_RADIUS = 'borderRadius',
  BORDER_WIDTH = 'borderWidth',
  BOX_SHADOW = 'boxShadow',
  COLOR = 'color',
  COLOR_BASE = 'color_base',
  LETTER_SPACING = 'letterSpacing',
  OPACITY = 'opacity',
  FONT_WEIGHTS = 'fontWeights',
  FONT_SIZES = 'fontSizes',
  LINE_HEIGHTS = 'lineHeights',
}
